import { ArrowRight } from "lucide-react";
import { industryLabel } from "../../data/results";
import { cx } from "../../lib/cx";
import { localHref, photoProps } from "../../lib/links";

/**
 * Photo-topped case-study card: trade tag, company, a one-line title and
 * summary. `project` is a moreProjects entry, or a headline study mapped
 * to the same shape. Screenshots sit whole on paper instead of cropped.
 */
export default function ProjectCard({
  path,
  project,
  headingLevel = 3,
  wide = false,
  className,
}) {
  const Heading = `h${headingLevel}`;
  return (
    <a
      href={localHref(path)}
      className={cx(
        "group flex flex-col overflow-hidden rounded-brand border border-line bg-white shadow-soft transition duration-200 hover:-translate-y-0.5 hover:shadow-lift motion-reduce:hover:translate-y-0",
        className,
      )}
    >
      <div
        className={cx(
          "relative aspect-[16/10] overflow-hidden",
          wide && "lg:aspect-[21/9]",
          project.screenshot ? "border-b border-line bg-white" : "bg-ink",
        )}
      >
        <img
          {...photoProps(
            project.photo,
            "(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 360px",
          )}
          alt=""
          loading="lazy"
          className={cx(
            "h-full w-full transition-transform duration-700 group-hover:scale-105",
            project.screenshot
              ? "object-contain px-6 pt-12 pb-4"
              : "object-cover",
          )}
        />
        <span className="tag absolute top-3 left-3 rounded-md bg-ink/85 px-2.5 py-1.5 font-semibold tracking-[0.12em] text-white backdrop-blur-sm">
          {industryLabel(project)}
        </span>
      </div>
      <div className="flex flex-1 flex-col px-6 pt-5 pb-6">
        <Heading className="font-display text-[22px] text-ink uppercase">
          {project.company}
        </Heading>
        <p className="mt-1 text-[15px] font-bold text-slate">{project.title}</p>
        <p className="mt-2.5 text-[15px] leading-relaxed text-muted">
          {project.summary}
        </p>
        <span className="mt-auto flex items-center gap-2 pt-5 text-[15px] font-bold text-blue-deep transition-colors group-hover:text-ink">
          Read the case study <ArrowRight size={17} aria-hidden="true" />
        </span>
      </div>
    </a>
  );
}
